import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Lightbulb, Building2 } from "lucide-react";
import { Logo } from "@/components/Logo";

const AUDIENCE = [
  { to: "/gruender", label: "Für Gründer", icon: Lightbulb },
  { to: "/business", label: "Für bestehendes Business", icon: Building2 },
];

export const SiteHeader = () => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const isActive = (to) => pathname === to;

  return (
    <header className="border-b border-slate-200/70 bg-white/80 backdrop-blur-xl sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="site-header-logo" aria-label="Zur Startseite">
          <Logo size="md" />
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {AUDIENCE.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.to === "/gruender" ? "gruender" : "business"}`}
                className={`inline-flex items-center gap-1.5 text-sm transition-colors ${
                  isActive(item.to) ? "text-slate-900 font-semibold" : "text-slate-500 hover:text-slate-900"
                }`}
              >
                <Icon className="h-4 w-4" style={{ color: isActive(item.to) ? "var(--brand-solid)" : "currentColor" }} />
                {item.label}
              </Link>
            );
          })}
          <button
            data-testid="nav-cta-start"
            onClick={() => nav(pathname === "/business" ? "/business" : "/gruender")}
            className="inline-flex items-center gap-1.5 h-10 px-5 rounded-xl text-sm font-semibold brand-gradient-bg text-white hover:opacity-95 transition-opacity shadow-sm"
          >
            Kostenlos starten <ArrowRight className="h-4 w-4" />
          </button>
        </nav>

        {/* Mobile: compact audience switch */}
        <div className="md:hidden inline-flex p-1 rounded-full bg-slate-100 border border-slate-200" data-testid="nav-mobile-audience">
          {AUDIENCE.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              data-testid={`nav-mobile-${item.to === "/gruender" ? "gruender" : "business"}`}
              className={`px-3 py-1.5 text-xs font-semibold rounded-full transition-colors ${
                isActive(item.to) ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"
              }`}
            >
              {item.to === "/gruender" ? "Gründer" : "Business"}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
